// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1FIYZ","info":"UpdateTermsInfo_info__3hUvb"};